import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LoggedOut, fetchUserDetails } from "../../../Pages/Login/loginSlice";
import {
  getWorkOsUserById,
  getEntityAcess,
  addEntityAcess,
} from "../users/invite-modal/InviteModalSlice";

const useMyProfile = () => {
  const dispatch = useDispatch();
  const timezone = useSelector((state) => state.login.timezone || "");
  const [serviceAvailable, setServiceAvailable] = useState([]);
  const [paginationFirst, setPaginationFirst] = useState(0);
  const [paginationRows, setPaginationRows] = useState(10);
  const [isUpateTimezone, setIsUpateTimezone] = useState(false);

  const user_id = useSelector((state) => state.login.id || null);

  const firstName = useSelector((state) => state.login.firstName || "");
  const lastName = useSelector((state) => state.login.lastName || "");
  const workos = useSelector((state) => state.inviteusers.workosuser || {});
  const userdata = {
    ...workos,
    firstName: firstName,
    lastName: lastName,
    timezone: timezone,
  };
  const myentityaccess = useSelector(
    (state) => state.inviteusers.useraccess || [],
  );

  const handleLogout = () => {
    dispatch(LoggedOut());
  };

  useEffect(() => {
    dispatch(getWorkOsUserById(user_id));
    dispatch(getEntityAcess(user_id));
  }, [user_id]);

  useEffect(() => {
    const uniqueServices = [];
    const serviceIds = new Set();
    myentityaccess.forEach((item) => {
      item.services.forEach((service) => {
        if (!serviceIds.has(service.id)) {
          serviceIds.add(service.id);
          uniqueServices.push(service);
        }
      });
    });
    setServiceAvailable(uniqueServices);
  }, [myentityaccess]);

  const paginationOnchange = (e) => {
    setPaginationFirst(e.first);
    setPaginationRows(e.rows);
  };

  const handleUpdateTimezone = (value) => {
    const payload = {
      id: user_id,
      timezone: value,
    };
    setIsUpateTimezone(true);
    dispatch(addEntityAcess(payload)).then(() => {
      dispatch(fetchUserDetails()).then(() => {
        setIsUpateTimezone(false);
      });
    });
  };

  return {
    handleLogout,
    userdata,
    myentityaccess,
    serviceAvailable,
    isUpateTimezone,
    paginationFirst,
    paginationRows,
    paginationOnchange,
    handleUpdateTimezone,
  };
};

export default useMyProfile;
